import Cookies from "js-cookie";
import { prefix } from "@/constants/const_var";

// 动态获取 prefix 的函数
const getPrefix = () => {
  return prefix;
};

export const CookiesStorage = {
  getItem: (key: string) => {
    const currentPrefix = getPrefix();
    const value: any = Cookies.get(currentPrefix + key);
    if (isEmptyType(value)) return "";
    if (isJSONString(value) && isEnableParse(value)) {
      return JSON.parse(value);
    }
    return value;
  },
  setItem: (key: string, value: any, duration = 8 * 60 * 60 * 1000) => {
    const currentPrefix = getPrefix();
    if (isEmptyType(value)) return;
    if (isObject(value)) {
      value = JSON.stringify(value);
    }
    const expires = new Date(Date.now() + duration);
    Cookies.set(currentPrefix + key, value, { expires });
  },
  removeItem: (key: string) => {
    const currentPrefix = getPrefix();
    Cookies.remove(currentPrefix + key);
  },
};

export const SessionStorage = {
  getItem: (key: string) => {
    const currentPrefix = getPrefix();
    const value: any = sessionStorage.getItem(currentPrefix + key);
    if (isEmptyType(value)) return "";
    if (isJSONString(value) && isEnableParse(value)) {
      return JSON.parse(value);
    }
    return value;
  },
  setItem: (key: string, value: any) => {
    const currentPrefix = getPrefix();
    if (isEmptyType(value)) return;
    if (isObject(value) || isArray(value)) {
      sessionStorage.setItem(currentPrefix + key, JSON.stringify(value));
      return;
    }
    sessionStorage.setItem(currentPrefix + key, value);
  },
  removeItem: (key: string) => {
    const currentPrefix = getPrefix();
    sessionStorage.removeItem(currentPrefix + key);
  },
  clear() {
    sessionStorage.clear();
  },
  key: (index: number) => {
    return sessionStorage.key(index);
  },
  length: sessionStorage.length,
};

export const LocalStorage = {
  getItem: (key: string) => {
    const currentPrefix = getPrefix();
    const value: any = localStorage.getItem(currentPrefix + key);
    if (isEmptyType(value)) return "";
    if (isJSONString(value) && isEnableParse(value)) {
      return JSON.parse(value);
    }
    return value;
  },
  setItem: (key: string, value: any) => {
    const currentPrefix = getPrefix();
    if (isEmptyType(value)) return;
    if (isObject(value)) {
      localStorage.setItem(currentPrefix + key, JSON.stringify(value));
      return;
    }
    localStorage.setItem(currentPrefix + key, value);
  },
  removeItem: (key: string) => {
    const currentPrefix = getPrefix();
    localStorage.removeItem(currentPrefix + key);
  },
  clear(excludeKeys?: string[]) {
    const currentPrefix = getPrefix();
    if (isEmptyType(excludeKeys)) {
      localStorage.clear();
      return;
    }
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(currentPrefix) && !excludeKeys?.includes(key.replace(currentPrefix, ""))) {
        localStorage.removeItem(key);
      }
    }
  },
  key: (index: number) => {
    return localStorage.key(index);
  },
  length: localStorage.length,
};

// 通用清理工具
export const StorageCleanup = {
  // 清理 sessionStorage 中指定前缀的键
  clearSessionStorageByPrefix: (prefix: string) => {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => {
      sessionStorage.removeItem(key);
    });
  },

  // 清理 localStorage 中指定前缀的键
  clearLocalStorageByPrefix: (prefix: string) => {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
  },

  // 清理 cookies 中指定前缀的键
  clearCookiesByPrefix: (prefix: string) => {
    const cookies = Cookies.get();
    Object.keys(cookies).forEach(cookieKey => {
      if (cookieKey.startsWith(prefix)) {
        Cookies.remove(cookieKey);
      }
    });
  },

  // 清理所有存储中指定前缀的键
  clearAllByPrefix: (prefix: string) => {
    StorageCleanup.clearSessionStorageByPrefix(prefix);
    StorageCleanup.clearLocalStorageByPrefix(prefix);
    StorageCleanup.clearCookiesByPrefix(prefix);
  },

  // 清理所有存储中当前前缀的键
  clearAllCurrentPrefix: () => {
    const currentPrefix = getPrefix();
    StorageCleanup.clearAllByPrefix(currentPrefix);
  },

  // 页面卸载前清理指定前缀的 sessionStorage
  setupBeforeUnloadCleanup: (prefix: string) => {
    window.onbeforeunload = () => {
      StorageCleanup.clearSessionStorageByPrefix(prefix);
    };
  },
};
